var AnimationTypes;
(function (AnimationTypes) {
  /* SCALE_UP */
  AnimationTypes["SCALE_UP_BL"] = "scale-up-bl";
  AnimationTypes["SCALE_UP_BOTTOM"] = "scale-up-bottom";
  AnimationTypes["SCALE_UP_BR"] = "scale-up-br";
  AnimationTypes["SCALE_UP_CENTER"] = "scale-up-center";
  AnimationTypes["SCALE_UP_HOR_CENTER"] = "scale-up-hor-center";
  AnimationTypes["SCALE_UP_HOR_LEFT"] = "scale-up-hor-left";
  AnimationTypes["SCALE_UP_HOR_RIGHT"] = "scale-up-hor-right";
  AnimationTypes["SCALE_UP_LEFT"] = "scale-up-left";
  AnimationTypes["SCALE_UP_RIGHT"] = "scale-up-right";
  AnimationTypes["SCALE_UP_TL"] = "scale-up-tl";
  AnimationTypes["SCALE_UP_TOP"] = "scale-up-top";
  AnimationTypes["SCALE_UP_TR"] = "scale-up-tr";
  AnimationTypes["SCALE_UP_VER_BOTTOM"] = "scale-up-ver-bottom";
  AnimationTypes["SCALE_UP_VER_CENTER"] = "scale-up-ver-center";
  AnimationTypes["SCALE_UP_VER_TOP"] = "scale-up-ver-top";
  /* SCALE_DOWN */
  AnimationTypes["SCALE_DOWN_BL"] = "scale-down-bl";
  AnimationTypes["SCALE_DOWN_BOTTOM"] = "scale-down-bottom";
  AnimationTypes["SCALE_DOWN_BR"] = "scale-down-br";
  AnimationTypes["SCALE_DOWN_CENTER"] = "scale-down-center";
  AnimationTypes["SCALE_DOWN_HOR_CENTER"] = "scale-down-hor-center";
  AnimationTypes["SCALE_DOWN_HOR_LEFT"] = "scale-down-hor-left";
  AnimationTypes["SCALE_DOWN_HOR_RIGHT"] = "scale-down-hor-right";
  AnimationTypes["SCALE_DOWN_LEFT"] = "scale-down-left";
  AnimationTypes["SCALE_DOWN_RIGHT"] = "scale-down-right";
  AnimationTypes["SCALE_DOWN_TL"] = "scale-down-tl";
  AnimationTypes["SCALE_DOWN_TOP"] = "scale-down-top";
  AnimationTypes["SCALE_DOWN_TR"] = "scale-down-tr";
  AnimationTypes["SCALE_DOWN_VER_BOTTOM"] = "scale-down-ver-bottom";
  AnimationTypes["SCALE_DOWN_VER_CENTER"] = "scale-down-ver-center";
  AnimationTypes["SCALE_DOWN_VER_TOP"] = "scale-down-ver-top";
  /* ROTATE */
  AnimationTypes["ROTATE_BL"] = "rotate-bl";
  AnimationTypes["ROTATE_BOTTOM"] = "rotate-bottom";
  AnimationTypes["ROTATE_BR"] = "rotate-br";
  AnimationTypes["ROTATE_CENTER"] = "rotate-center";
  AnimationTypes["ROTATE_DIAGONAL_1"] = "rotate-diagonal-1";
  AnimationTypes["ROTATE_DIAGONAL_2"] = "rotate-diagonal-2";
  AnimationTypes["ROTATE_DIAGONAL_BL"] = "rotate-diagonal-bl";
  AnimationTypes["ROTATE_DIAGONAL_BR"] = "rotate-diagonal-br";
  AnimationTypes["ROTATE_DIAGONAL_TL"] = "rotate-diagonal-tl";
  AnimationTypes["ROTATE_DIAGONAL_TR"] = "rotate-diagonal-tr";
  AnimationTypes["ROTATE_HOR_BOTTOM"] = "rotate-hor-bottom";
  AnimationTypes["ROTATE_HOR_CENTER"] = "rotate-hor-center";
  AnimationTypes["ROTATE_HOR_TOP"] = "rotate-hor-top";
  AnimationTypes["ROTATE_LEFT"] = "rotate-left";
  AnimationTypes["ROTATE_RIGHT"] = "rotate-right";
  AnimationTypes["ROTATE_TL"] = "rotate-tl";
  AnimationTypes["ROTATE_TOP"] = "rotate-top";
  AnimationTypes["ROTATE_TR"] = "rotate-tr";
  AnimationTypes["ROTATE_VERT_CENTER"] = "rotate-vert-center";
  AnimationTypes["ROTATE_VERT_LEFT"] = "rotate-vert-left";
  AnimationTypes["ROTATE_VERT_RIGHT"] = "rotate-vert-right";
  /* ROTATE_SCALE */
  AnimationTypes["ROTATE_SCALE_DOWN"] = "rotate-scale-down";
  AnimationTypes["ROTATE_SCALE_DOWN_DIAG_1"] = "rotate-scale-down-diag-1";
  AnimationTypes["ROTATE_SCALE_DOWN_DIAG_2"] = "rotate-scale-down-diag-2";
  AnimationTypes["ROTATE_SCALE_DOWN_HOR"] = "rotate-scale-down-hor";
  AnimationTypes["ROTATE_SCALE_DOWN_VER"] = "rotate-scale-down-ver";
  AnimationTypes["ROTATE_SCALE_UP"] = "rotate-scale-up";
  AnimationTypes["ROTATE_SCALE_UP_DIAG_1"] = "rotate-scale-up-diag-1";
  AnimationTypes["ROTATE_SCALE_UP_DIAG_2"] = "rotate-scale-up-diag-2";
  AnimationTypes["ROTATE_SCALE_UP_HOR"] = "rotate-scale-up-hor";
  AnimationTypes["ROTATE_SCALE_UP_VER"] = "rotate-scale-up-ver";
  /* ROTATE_90 */
  AnimationTypes["ROTATE_90_BL_CCW"] = "rotate-90-bl-ccw";
  AnimationTypes["ROTATE_90_BL_CW"] = "rotate-90-bl-cw";
  AnimationTypes["ROTATE_90_BOTTOM_CCW"] = "rotate-90-bottom-ccw";
  AnimationTypes["ROTATE_90_BOTTOM_CW"] = "rotate-90-bottom-cw";
  AnimationTypes["ROTATE_90_BR_CCW"] = "rotate-90-br-ccw";
  AnimationTypes["ROTATE_90_BR_CW"] = "rotate-90-br-cw";
  AnimationTypes["ROTATE_90_CCW"] = "rotate-90-ccw";
  AnimationTypes["ROTATE_90_CW"] = "rotate-90-cw";
  AnimationTypes["ROTATE_90_HORIZONTAL_BCK"] = "rotate-90-horizontal-bck";
  AnimationTypes["ROTATE_90_HORIZONTAL_FWD"] = "rotate-90-horizontal-fwd";
  AnimationTypes["ROTATE_90_LEFT_CCW"] = "rotate-90-left-ccw";
  AnimationTypes["ROTATE_90_LEFT_CW"] = "rotate-90-left-cw";
  AnimationTypes["ROTATE_90_RIGHT_CCW"] = "rotate-90-right-ccw";
  AnimationTypes["ROTATE_90_RIGHT_CW"] = "rotate-90-right-cw";
  AnimationTypes["ROTATE_90_TL_CCW"] = "rotate-90-tl-ccw";
  AnimationTypes["ROTATE_90_TL_CW"] = "rotate-90-tl-cw";
  AnimationTypes["ROTATE_90_TOP_CCW"] = "rotate-90-top-ccw";
  AnimationTypes["ROTATE_90_TOP_CW"] = "rotate-90-top-cw";
  AnimationTypes["ROTATE_90_TR_CCW"] = "rotate-90-tr-ccw";
  AnimationTypes["ROTATE_90_TR_CW"] = "rotate-90-tr-cw";
  AnimationTypes["ROTATE_90_VERTICAL_BCK"] = "rotate-90-vertical-bck";
  AnimationTypes["ROTATE_90_VERTICAL_FWD"] = "rotate-90-vertical-fwd";
  /* FLIP */
  AnimationTypes["FLIP_DIAGONAL_1_BCK"] = "flip-diagonal-1-bck";
  AnimationTypes["FLIP_DIAGONAL_1_BL"] = "flip-diagonal-1-bl";
  AnimationTypes["FLIP_DIAGONAL_1_FWD"] = "flip-diagonal-1-fwd";
  AnimationTypes["FLIP_DIAGONAL_1_TR"] = "flip-diagonal-1-tr";
  AnimationTypes["FLIP_DIAGONAL_2_BCK"] = "flip-diagonal-2-bck";
  AnimationTypes["FLIP_DIAGONAL_2_BR"] = "flip-diagonal-2-br";
  AnimationTypes["FLIP_DIAGONAL_2_FWD"] = "flip-diagonal-2-fwd";
  AnimationTypes["FLIP_DIAGONAL_2_TL"] = "flip-diagonal-2-tl";
  AnimationTypes["FLIP_HORIZONTAL_BCK"] = "flip-horizontal-bck";
  AnimationTypes["FLIP_HORIZONTAL_BOTTOM"] = "flip-horizontal-bottom";
  AnimationTypes["FLIP_HORIZONTAL_FWD"] = "flip-horizontal-fwd";
  AnimationTypes["FLIP_HORIZONTAL_TOP"] = "flip-horizontal-top";
  AnimationTypes["FLIP_VERTICAL_BCK"] = "flip-vertical-bck";
  AnimationTypes["FLIP_VERTICAL_FWD"] = "flip-vertical-fwd";
  AnimationTypes["FLIP_VERTICAL_LEFT"] = "flip-vertical-left";
  AnimationTypes["FLIP_VERTICAL_RIGHT"] = "flip-vertical-right";
  /* FLIP_2 */
  AnimationTypes["FLIP_2_HOR_BOTTOM_1"] = "flip-2-hor-bottom-1";
  AnimationTypes["FLIP_2_HOR_BOTTOM_2"] = "flip-2-hor-bottom-2";
  AnimationTypes["FLIP_2_HOR_BOTTOM_BCK"] = "flip-2-hor-bottom-bck";
  AnimationTypes["FLIP_2_HOR_BOTTOM_FWD"] = "flip-2-hor-bottom-fwd";
  AnimationTypes["FLIP_2_HOR_TOP_1"] = "flip-2-hor-top-1";
  AnimationTypes["FLIP_2_HOR_TOP_2"] = "flip-2-hor-top-2";
  AnimationTypes["FLIP_2_HOR_TOP_BCK"] = "flip-2-hor-top-bck";
  AnimationTypes["FLIP_2_HOR_TOP_FWD"] = "flip-2-hor-top-fwd";
  AnimationTypes["FLIP_2_VER_LEFT_1"] = "flip-2-ver-left-1";
  AnimationTypes["FLIP_2_VER_LEFT_2"] = "flip-2-ver-left-2";
  AnimationTypes["FLIP_2_VER_LEFT_BCK"] = "flip-2-ver-left-bck";
  AnimationTypes["FLIP_2_VER_LEFT_FWD"] = "flip-2-ver-left-fwd";
  AnimationTypes["FLIP_2_VER_RIGHT_1"] = "flip-2-ver-right-1";
  AnimationTypes["FLIP_2_VER_RIGHT_2"] = "flip-2-ver-right-2";
  AnimationTypes["FLIP_2_VER_RIGHT_BCK"] = "flip-2-ver-right-bck";
  AnimationTypes["FLIP_2_VER_RIGHT_FWD"] = "flip-2-ver-right-fwd";
  /* FLIP_SCALE */
  AnimationTypes["FLIP_SCALE_DOWN_DIAG_1"] = "flip-scale-down-diag-1";
  AnimationTypes["FLIP_SCALE_DOWN_DIAG_2"] = "flip-scale-down-diag-2";
  AnimationTypes["FLIP_SCALE_DOWN_HOR"] = "flip-scale-down-hor";
  AnimationTypes["FLIP_SCALE_DOWN_VER"] = "flip-scale-down-ver";
  AnimationTypes["FLIP_SCALE_UP_DIAG_1"] = "flip-scale-up-diag-1";
  AnimationTypes["FLIP_SCALE_UP_DIAG_2"] = "flip-scale-up-diag-2";
  AnimationTypes["FLIP_SCALE_UP_HOR"] = "flip-scale-up-hor";
  AnimationTypes["FLIP_SCALE_UP_VER"] = "flip-scale-up-ver";
  /* FLIP_SCALE_2 */
  AnimationTypes["FLIP_SCALE_2_HOR_BOTTOM"] = "flip-scale-2-hor-bottom";
  AnimationTypes["FLIP_SCALE_2_HOR_TOP"] = "flip-scale-2-hor-top";
  AnimationTypes["FLIP_SCALE_2_VER_LEFT"] = "flip-scale-2-ver-left";
  AnimationTypes["FLIP_SCALE_2_VER_RIGHT"] = "flip-scale-2-ver-right";
  /* SWING */
  AnimationTypes["SWING_BOTTOM_BCK"] = "swing-bottom-bck";
  AnimationTypes["SWING_BOTTOM_FWD"] = "swing-bottom-fwd";
  AnimationTypes["SWING_BOTTOM_LEFT_BCK"] = "swing-bottom-left-bck";
  AnimationTypes["SWING_BOTTOM_LEFT_FWD"] = "swing-bottom-left-fwd";
  AnimationTypes["SWING_BOTTOM_RIGHT_BCK"] = "swing-bottom-right-bck";
  AnimationTypes["SWING_BOTTOM_RIGHT_FWD"] = "swing-bottom-right-fwd";
  AnimationTypes["SWING_LEFT_BCK"] = "swing-left-bck";
  AnimationTypes["SWING_LEFT_FWD"] = "swing-left-fwd";
  AnimationTypes["SWING_RIGHT_BCK"] = "swing-right-bck";
  AnimationTypes["SWING_RIGHT_FWD"] = "swing-right-fwd";
  AnimationTypes["SWING_TOP_BCK"] = "swing-top-bck";
  AnimationTypes["SWING_TOP_FWD"] = "swing-top-fwd";
  AnimationTypes["SWING_TOP_LEFT_BCK"] = "swing-top-left-bck";
  AnimationTypes["SWING_TOP_LEFT_FWD"] = "swing-top-left-fwd";
  AnimationTypes["SWING_TOP_RIGHT_BCK"] = "swing-top-right-bck";
  AnimationTypes["SWING_TOP_RIGHT_FWD"] = "swing-top-right-fwd";
  /* SLIDE */
  AnimationTypes["SLIDE_BL"] = "slide-bl";
  AnimationTypes["SLIDE_BOTTOM"] = "slide-bottom";
  AnimationTypes["SLIDE_BR"] = "slide-br";
  AnimationTypes["SLIDE_LEFT"] = "slide-left";
  AnimationTypes["SLIDE_RIGHT"] = "slide-right";
  AnimationTypes["SLIDE_TL"] = "slide-tl";
  AnimationTypes["SLIDE_TOP"] = "slide-top";
  AnimationTypes["SLIDE_TR"] = "slide-tr";
  /* SLIDE_BCK */
  AnimationTypes["SLIDE_BCK_BL"] = "slide-bck-bl";
  AnimationTypes["SLIDE_BCK_BOTTOM"] = "slide-bck-bottom";
  AnimationTypes["SLIDE_BCK_BR"] = "slide-bck-br";
  AnimationTypes["SLIDE_BCK_CENTER"] = "slide-bck-center";
  AnimationTypes["SLIDE_BCK_LEFT"] = "slide-bck-left";
  AnimationTypes["SLIDE_BCK_RIGHT"] = "slide-bck-right";
  AnimationTypes["SLIDE_BCK_TL"] = "slide-bck-tl";
  AnimationTypes["SLIDE_BCK_TOP"] = "slide-bck-top";
  AnimationTypes["SLIDE_BCK_TR"] = "slide-bck-tr";
  /* SLIDE_FWD */
  AnimationTypes["SLIDE_FWD_BL"] = "slide-fwd-bl";
  AnimationTypes["SLIDE_FWD_BOTTOM"] = "slide-fwd-bottom";
  AnimationTypes["SLIDE_FWD_BR"] = "slide-fwd-br";
  AnimationTypes["SLIDE_FWD_CENTER"] = "slide-fwd-center";
  AnimationTypes["SLIDE_FWD_LEFT"] = "slide-fwd-left";
  AnimationTypes["SLIDE_FWD_RIGHT"] = "slide-fwd-right";
  AnimationTypes["SLIDE_FWD_TL"] = "slide-fwd-tl";
  AnimationTypes["SLIDE_FWD_TOP"] = "slide-fwd-top";
  AnimationTypes["SLIDE_FWD_TR"] = "slide-fwd-tr";
  /* SLIDE_ROTATE */
  AnimationTypes["SLIDE_ROTATE_HOR_B_BCK"] = "slide-rotate-hor-b-bck";
  AnimationTypes["SLIDE_ROTATE_HOR_B_FWD"] = "slide-rotate-hor-b-fwd";
  AnimationTypes["SLIDE_ROTATE_HOR_BOTTOM"] = "slide-rotate-hor-bottom";
  AnimationTypes["SLIDE_ROTATE_HOR_T_BCK"] = "slide-rotate-hor-t-bck";
  AnimationTypes["SLIDE_ROTATE_HOR_T_FWD"] = "slide-rotate-hor-t-fwd";
  AnimationTypes["SLIDE_ROTATE_HOR_TOP"] = "slide-rotate-hor-top";
  AnimationTypes["SLIDE_ROTATE_VER_L_BCK"] = "slide-rotate-ver-l-bck";
  AnimationTypes["SLIDE_ROTATE_VER_L_FWD"] = "slide-rotate-ver-l-fwd";
  AnimationTypes["SLIDE_ROTATE_VER_LEFT"] = "slide-rotate-ver-left";
  AnimationTypes["SLIDE_ROTATE_VER_R_BCK"] = "slide-rotate-ver-r-bck";
  AnimationTypes["SLIDE_ROTATE_VER_R_FWD"] = "slide-rotate-ver-r-fwd";
  AnimationTypes["SLIDE_ROTATE_VER_RIGHT"] = "slide-rotate-ver-right";
  /* SHADOW_DROP */
  AnimationTypes["SHADOW_DROP_BL"] = "shadow-drop-bl";
  AnimationTypes["SHADOW_DROP_BOTTOM"] = "shadow-drop-bottom";
  AnimationTypes["SHADOW_DROP_BR"] = "shadow-drop-br";
  AnimationTypes["SHADOW_DROP_CENTER"] = "shadow-drop-center";
  AnimationTypes["SHADOW_DROP_LEFT"] = "shadow-drop-left";
  AnimationTypes["SHADOW_DROP_LR"] = "shadow-drop-lr";
  AnimationTypes["SHADOW_DROP_RIGHT"] = "shadow-drop-right";
  AnimationTypes["SHADOW_DROP_TB"] = "shadow-drop-tb";
  AnimationTypes["SHADOW_DROP_TL"] = "shadow-drop-tl";
  AnimationTypes["SHADOW_DROP_TOP"] = "shadow-drop-top";
  AnimationTypes["SHADOW_DROP_TR"] = "shadow-drop-tr";
  /* SHADOW_DROP_2 */
  AnimationTypes["SHADOW_DROP_2_BL"] = "shadow-drop-2-bl";
  AnimationTypes["SHADOW_DROP_2_BOTTOM"] = "shadow-drop-2-bottom";
  AnimationTypes["SHADOW_DROP_2_BR"] = "shadow-drop-2-br";
  AnimationTypes["SHADOW_DROP_2_CENTER"] = "shadow-drop-2-center";
  AnimationTypes["SHADOW_DROP_2_LEFT"] = "shadow-drop-2-left";
  AnimationTypes["SHADOW_DROP_2_LR"] = "shadow-drop-2-lr";
  AnimationTypes["SHADOW_DROP_2_RIGHT"] = "shadow-drop-2-right";
  AnimationTypes["SHADOW_DROP_2_TB"] = "shadow-drop-2-tb";
  AnimationTypes["SHADOW_DROP_2_TL"] = "shadow-drop-2-tl";
  AnimationTypes["SHADOW_DROP_2_TOP"] = "shadow-drop-2-top";
  AnimationTypes["SHADOW_DROP_2_TR"] = "shadow-drop-2-tr";
  /* SHADOW_POP */
  AnimationTypes["SHADOW_POP_BL"] = "shadow-pop-bl";
  AnimationTypes["SHADOW_POP_BR"] = "shadow-pop-br";
  AnimationTypes["SHADOW_POP_TL"] = "shadow-pop-tl";
  AnimationTypes["SHADOW_POP_TR"] = "shadow-pop-tr";
  /* SHADOW_INSET */
  AnimationTypes["SHADOW_INSET_BL"] = "shadow-inset-bl";
  AnimationTypes["SHADOW_INSET_BOTTOM"] = "shadow-inset-bottom";
  AnimationTypes["SHADOW_INSET_BR"] = "shadow-inset-br";
  AnimationTypes["SHADOW_INSET_CENTER"] = "shadow-inset-center";
  AnimationTypes["SHADOW_INSET_LEFT"] = "shadow-inset-left";
  AnimationTypes["SHADOW_INSET_LR"] = "shadow-inset-lr";
  AnimationTypes["SHADOW_INSET_RIGHT"] = "shadow-inset-right";
  AnimationTypes["SHADOW_INSET_TB"] = "shadow-inset-tb";
  AnimationTypes["SHADOW_INSET_TL"] = "shadow-inset-tl";
  AnimationTypes["SHADOW_INSET_TOP"] = "shadow-inset-top";
  AnimationTypes["SHADOW_INSET_TR"] = "shadow-inset-tr";
})(AnimationTypes || (AnimationTypes = {}));
export default AnimationTypes;